<template>
  <section class="reply-card" @mouseenter="isHover= true" @mouseleave="isHover=false"  @click="hideTextarea">
    <div class="header">
      <div class="userInfo" :class="{'userType2':item.userType === 2 && item.isCertification === 1,isChild:isChild}">
        <router-link
          target="_blank"
          :to="`/peopleCenter/${item.userId}`"
          :class="{'userType2':item.userType === 2 && item.isCertification === 1,isChild:isChild}"
        >
          <img :src="item.userAvatar| imageUrl('',imageWidth,imageWidth)" alt />
          <span class="nickname">{{item.userNickName}}</span>
        </router-link>
        <span class="time">{{item.createTime | dateToNow(language)}}</span>
      </div>
      <el-popover placement="bottom" width="74" v-model="visible">
        <edit-or-report
          :id="item.id"
          :isUser="isUser"
          @delete="deleteReply"
          @report="reportAnswer"
        />
        <img src="/static/v2/article/comment_more.png" slot="reference" class="popover" />
      </el-popover>
    </div>
    <div class="content" v-if="!isChild">{{item.content}}</div>
    <div class="content isChild" v-else>
      <span v-if="item.atUserNickName">
        <span>{{$t('global.回复')}}</span>
        @
        <router-link target="_blank" :to="`/peopleCenter/${item.atUserId}`">{{item.atUserNickName}}</router-link>
      </span>
      {{item.content}}
    </div>
    <div class="footer" :class="{isChild:isChild}">
      <img @click="answerLike" v-if="!item.isLike" src="/static/v2/article/comment_clap.png" alt />
      <img @click="answerLike" v-else src="/static/v2/article/comment_clap_active.png" />
      <span class="like-count" :class="{active:item.isLike}">{{item.likeCount}}</span>
      <span class="reply-click" @click.stop.prevent="replyShow" v-show="isHover">{{$t('global.回复')}}</span>
      <div v-if="showTextarea" @click.stop.prevent>
        <el-input
          type="textarea"
          :rows="2"
          :placeholder="`${$t('global.回复')}@${item.userNickName}`"
          v-model="replyContent"
        ></el-input>
        <el-button @click="SubmitComment">{{$t('global.回复')}}</el-button>
      </div>
    </div>
    <report-dialog
      :questionId="item.id"
      report-type="2"
      :report-visible="reportVisible"
      @close-after="reportVisible = false"
    ></report-dialog>
  </section>
</template>

<script>
import EditOrReport from "@/components/v2/EditOrReport";
import ReportDialog from "@/components/topic/ReportDialog";
export default {
  props: ["item", "imageWidth", "isChild", "parentId"],
  components: {
    EditOrReport,
    ReportDialog
  },
  data() {
    return {
      visible: false,
      isHover: false,
      replyContent: "",
      showTextarea: false,
      reportVisible: false,
      reportItem: null,
      isUser: false
    };
  },
  created() {
    if (
      this.$store.state.peopleMessage &&
      this.$store.state.peopleMessage.userId == this.item.userId
    ) {
      this.isUser = true;
    }
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  methods: {
    hideTextarea() {
        this.showTextarea = false;
    },
    replyShow() {
      if (localStorage.getItem("auth_token")) {
        this.showTextarea = !this.showTextarea;
      } else {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      }
    },
    replyAnswer() {
      const url = `/api/u/topicanswer/create`;
      const params = {
        content: this.replyContent,
        topicQuestionId: this.item.topicQuestionId,
        parentAnswerUserId: this.item.userId,
        parentId: this.parentId || this.item.id
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.replyContent = "";
          this.$message.success("评论成功");
          this.showTextarea = false;
        }
      });
    },
    SubmitComment() {
      //   const flag = this.$islogin();
      if (!this.replyContent.replace(/[\r\n\s]/g,"")) {
        this.$message.error(this.$t("global.回复内容不能为空"));
        return;
      }
      if (this.replyContent.length > 5000) {
        this.$message.error(
          this.$t("global.回复内容不能超过") + "5000" + this.$t("global.字")
        );
        return false;
      }
      let url = "";
      let params = {};
      if (this.isChild) {
        url = `/api/u/comment/createReplyNew`;
        params = {
          commentId: this.parentId,
          commentChildId: this.item.id,
          content: this.replyContent
        };
      } else {
        url = "/api/u/comment/createReply";
        params = {
          commentId: this.item.id,
          content: this.replyContent
        };
      }
      this.$http
        .post(url, {
          ...params
        })
        .then(res => {
          if (res.code == "OK") {
            this.replyContent = "";
            this.$emit("refresh");
          } else {
            this.$message(res.message);
          }
        });
    },
    deleteReply() {
      const url = `/api/mobile/comment/delete/` + this.item.id;
      this.$http.post(url).then(res => {
        if (res.code === "OK") {
          this.$message.success("删除成功");
          this.$emit("refresh");
        }
      });
    },
    reportAnswer() {
      this.reportVisible = true;
    },
    answerLike() {
      const url = `/api/u/comment/commentLikeOrCancel`;
      const params = {
        commentId: this.item.id
      };
      this.$http.post(url, params).then(res => {
        if (res.code == "OK") {
          this.$message(res.message);
          if (this.item.isLike&&this.item.likeCount > 0) {
            this.item.likeCount--;
            this.item.isLike = false;    
          } else {
            this.item.likeCount++;
            this.item.isLike = true;  
          }
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.reply-card {
  overflow: auto;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0;

    .userInfo {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;

      a {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;

        &.userType2::before {
          content: '';
          left: 25px;
          bottom: 0;
          position: absolute;
          width: 16px;
          height: 16px;
          background: url('/static/v2/match/Verified_icon_blue_20.png');
          background-size: 16px;
        }

        img {
          width: 38px;
          height: 38px;
          border-radius: 100%;
          border: 1px solid #f5f5f5;
        }

        &.isChild {
          &.userType2::before {
            content: '';
            left: 20px;
            bottom: 0;
            position: absolute;
            width: 10px;
            height: 10px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 10px;
          }

          img {
            width: 28px;
            height: 28px;
            border-radius: 15px;
            border: 1px solid #f5f5f5;
          }
        }

        .nickname {
          padding-left: 10px;
          font-size: 15px;
          color: #000;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }

      span {
        &.time {
          font-size: 14px;
          color: #B8B8B8;
          padding-left: 20px;
        }
      }
    }

    .popover {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }

  .content {
    padding-top: 10px;
    padding-left: 50px;
    font-size: 15px;
    color: #0A0A0A;
    line-height: 24px;

    &.isChild {
      padding-left: 40px;

      span {
        color: #b8b8b8;
      }

      a {
        color: #0A0A0A;
      }
    }
  }

  .footer {
    padding: 15px 0 0 50px;

    &.isChild {
      padding-left: 40px;
    }

    img {
      width: 20px;
      height: 20px;
      vertical-align: sub;
      cursor: pointer;
    }

    span.like-count {
      font-size: 14px;
      color: #B8B8B8;

      &.active {
        color: #2026CC;
      }
    }

    span.reply-click {
      font-size: 14px;
      margin-left: 30px;
      cursor: pointer;
    }

    &>div {
      padding: 15px 0 15px 60px;

      .el-textarea {
        padding-bottom: 15px;
        width: 100%;
      }

      .el-button {
        background: #2026CC;
        color: #fff;
        width: 65px;
        height: 30px;
        padding: 5px 0;
        font-size: 14px;
        line-height: 20px;
        float: right;
        border-radius: 0;
        border: none;
      }
    }
  }
}

.article-detail .wrap .left .comment .reply-wrap .reply-list .children li .reply-card .header {
  height: 32px;
}
</style>

<style lang="stylus">
.reply-card .el-textarea .el-textarea__inner {
  background: #f5f5f5;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/VideoCard.vue